module.exports = __webpack_public_path__ + "static/media/Biosina.4dc1de05.svg";